import React, { Component } from "react";

import _ from "i18n";
import { SvgIcon } from "../Common/Icons";
import Bubble from "../Common/Bubble/Bubble";
import { TTP_HOME_URL, TTP_DASHBOARD_URL, TTP_UA_URL } from "Config";
import { inIframe, postMessage } from "Utils";
import classNames from "classnames";

export default class Bubbles extends Component {
  componentDidMount() {}

  renderNewUserLink = () => {
    const { withoutHeader } = this.props;

    const addUserLink = `${TTP_HOME_URL}/users/create`;
    const returnto = `${TTP_DASHBOARD_URL}/authorizations`;

    if (withoutHeader) {
      return (window.parent.location = `${TTP_UA_URL}/settings`);
    }

    if (inIframe()) {
      return postMessage("ajouter un nouveau utilisateur", "ADD_NEW_USER");
    } else return (window.location = `${addUserLink}?returnto=${returnto}`);
  };

  displaySetting = () => {
    const mask = document.getElementsByClassName("mask").item(0).classList;
    mask.remove("hide");
    console.dir(document.getElementsByClassName("mask").item(0));
    //  if (!inIframe()) {
    //    document.getElementById("mainMenu").style.zIndex = 6;
    //  }
    document.body.classList.add("hidden_overflow");
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    this.props.handleSettingsTab(true);
  };

  render() {
    let {
      handleToggleSelectAll,
      language,
      isSelectAll,
      isUserSelected,
      userType,
      withoutHeader
    } = this.props;
    return (
      <div
        className={classNames(
          "setting-bubbles",
          "bubbles_behaviour",
          inIframe() ? "inIframe" : ""
        )}
      >
        {userType === "LEGAL_REPRESENTATIVE" ||
        userType === "MANAGER" ||
        !withoutHeader ? (
          <div className="circleSvg" onClick={() => this.renderNewUserLink()}>
            <SvgIcon icon={"AddIcon"} />
            <span
              style={
                language === "en"
                  ? { paddingLeft: "1rem" }
                  : { paddingLeft: ".5rem" }
              }
            >
              {_("New user")}
            </span>
          </div>
        ) : (
          ""
        )}

        <div
          className={`${isSelectAll === true &&
            "active"} bubble__select-all circleSvg`}
          onClick={() => handleToggleSelectAll()}
        >
          {isUserSelected ? (
            <SvgIcon icon={"CloseIconCircle"} />
          ) : (
            <SvgIcon icon={"CheckAuthorisationIcon"} />
          )}

          <span
            style={
              language === "en"
                ? { paddingLeft: "1rem" }
                : { paddingLeft: ".5rem" }
            }
          >
            {isUserSelected ? _("Deselect All") : _("Select All")}
          </span>
        </div>

        {isUserSelected && (
          <Bubble
            onBubbleClick={() => this.displaySetting()}
            label="Preferences"
            svgIcon={<SvgIcon icon={"SettingIconEmpty"} />}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Authorizations/Bubbles.js